
import React, { useState, useEffect } from "react";
import './Testimonials.scss'
import { HiChevronLeft,HiChevronRight } from "react-icons/hi";

import { animate, easeInOut, motion } from "framer-motion";
import { urlFor, client } from "../../client";
import { AppWrap,MotionWrap } from "../../wrapper";

import { Tooltip as ReactTooltip } from 'react-tooltip';


const Testimonials = () => {
    const [brands, setBrands] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    
    const handleclick=(index)=>{
      setCurrentIndex(index)
    }
  useEffect(() => {
    const query = '*[_type=="brands"]';
    const testimonialQuery = '*[_type=="testimonials"]';
    client.fetch(query).then((data) => {
      setBrands(data);
      
    });

    client.fetch(testimonialQuery).then((data) => {
      setTestimonials(data);
    });
  }, []);

const test=testimonials[currentIndex]

  return (

    <>
    {testimonials.length && (
    <>
    <div className="app__testimonial-item app__flex">
      <img src={urlFor(test.imgurl)} alt="testimonials" />
      <div className="app__testimonial-content">
        <p className="p-text">{test.feedback}</p>
        <div>
        <h4 className="bold-text">{test.name}</h4>
        <h5 className="p-text">{test.company}</h5>
        </div>
      </div> 
     </div>
<div className="app__testmonials-btns app__flex">
<div className="app__flex" onClick={()=>handleclick(currentIndex===0?testimonials.length-1:currentIndex-1)}>
<HiChevronLeft/>
</div>

<div className="app__flex" onClick={()=>handleclick(currentIndex===testimonials.length-1?0:currentIndex+1)}>
<HiChevronRight/>
</div>
</div>
    </>
    )}
<div className="app__testimonials-brands app__flex">
    {brands.map((brand)=>(
      <motion.div
      whileInView={{opacity:[0,1]}}
      transition={{duration:0.5,type:'tween'}}
      key={brand._id}
      >
 <img src={urlFor(brand.imgUrl)} alt={brand.name}></img>
      </motion.div>  
    ))}
</div>


    </>

  )
}

export default AppWrap(
  MotionWrap(Testimonials,'app__testimonial'),'testimonial',
)
